import React from "react";
import "./kpi-card.css";

type DeltaDir = "up" | "down";

interface Props {
  scope: string;
  /** CSS color for the scope dot — any valid CSS value, e.g. "var(--pos)" or "#4a8bc4" */
  dotColor: string;
  amount: React.ReactNode;
  /** Token the amount is denominated in. Omitted while the figure is a skeleton or a dash. */
  unit?: string;
  subText: React.ReactNode;
  delta?: string;
  deltaDir?: DeltaDir;
}

function KpiCard({
  scope,
  dotColor,
  amount,
  unit,
  subText,
  delta,
  deltaDir,
}: Props) {
  return (
    <div className="kpi-card">
      <div className="kpi-card__scope">
        <span className="kpi-card__dot" style={{ background: dotColor }} />
        {scope}
      </div>
      <div className="kpi-card__amount">
        {amount}
        {unit && <span className="kpi-card__unit">{unit}</span>}
      </div>
      <div className="kpi-card__sub">
        <span>{subText}</span>
        {delta && deltaDir && (
          <span className={`kpi-card__delta kpi-card__delta--${deltaDir}`}>
            {deltaDir === "up" ? "▲" : "▼"} {delta}
          </span>
        )}
      </div>
    </div>
  );
}

export default KpiCard;
